var swiper = new Swiper('.swiper', {
  // Default parameters
  slidesPerView: 1,
  spaceBetween: 10,
  slidesPerGroup: 1,
  speed: 500,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: false,
  },
  loop: true,
  // Responsive breakpoints
  breakpoints: {
    320: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 15
    },
    768: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20
    },
    920: {
      slidesPerView: 6,
      slidesPerGroup: 6,
      spaceBetween: 30
    },
    // when window width is >= 640px
    1200: {
      slidesPerView: 8,
      slidesPerGroup: 8,
      spaceBetween: 20
    }
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
})